<div id="registration-confirmation">
    <div class="box">
        <div class="box-header"></div>
        <div class="box-content">
            <span class="message"></span>
            <a href="/">Back to start page</a>
        </div>
    </div>
</div>